import React from "react";

export default function TemplateIcon({ className, size = 14, strokeWidth = 1.401, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      aria-hidden="true"
      {...rest}
    >
      <rect width="4.905" height="2.803" x="0.701" y="0.701" rx="1.401" />
      <rect width="4.905" height="7.007" x="0.701" y="5.605" rx="1.752" />
      <rect width="4.905" height="7.007" x="7.708" y="0.701" rx="1.752" />
      <rect width="4.905" height="2.803" x="7.708" y="9.81" rx="1.401" />
    </svg>
  );
}
